import type { BlockResult } from '@/types/blocker'
import type { LevelWithUnderscores } from '@/types/journey'

import type { LevelUiStatus } from '../constants/status'

type LevelStatusInput = {
  level: LevelWithUnderscores
  blockResult: BlockResult
  currentLevelUid: string | undefined
}

export const getLevelUiStatus = ({
  level,
  blockResult,
  currentLevelUid
}: LevelStatusInput): LevelUiStatus => {
  if (!blockResult.unlocked) return 'locked'
  if (level._progress?.finished) return 'success'
  if (level.uid === currentLevelUid) return 'progress'
  return 'available'
}
